// Wspólne dla animacji: GSAP z wtyczkami (od wersji 3.13 wszystkie są darmowe) i drobne pomocniki.
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import {ScrambleTextPlugin} from "gsap/ScrambleTextPlugin";
import {CustomEase} from "gsap/CustomEase";
import {CustomWiggle} from "gsap/CustomWiggle";

gsap.registerPlugin(ScrollTrigger, SplitText, ScrambleTextPlugin, CustomEase, CustomWiggle);

// Wiggle kończy się w punkcie startu – idealne do merdania, dzwonienia i „Hau!”.
CustomWiggle.create("cc-wiggle", {wiggles: 6, type: "easeOut"});
CustomWiggle.create("cc-wag", {wiggles: 4, type: "easeOut"});
CustomWiggle.create("cc-ring", {wiggles: 9, type: "uniform"});

ScrollTrigger.config({ignoreMobileResize: true});

export {gsap, ScrollTrigger, SplitText};

// Łapka z ikon systemu projektowego jako jedna ścieżka (poduszka + 4 palce) – do śladów i konfetti.
export const PAW_PATH = "M12 11.3c-2.7 0-5.6 3.3-5.6 6.1 0 1.8 1.3 2.8 2.9 2.4 1-.3 1.8-.6 2.7-.6s1.7.3 2.7.6c1.6.4 2.9-.6 2.9-2.4 0-2.8-2.9-6.1-5.6-6.1Z"
    + "M3.5 10.4a1.9 2.4 0 1 0 3.8 0a1.9 2.4 0 1 0-3.8 0Z"
    + "M7.2 5.9a2 2.6 0 1 0 4 0a2 2.6 0 1 0-4 0Z"
    + "M12.8 5.9a2 2.6 0 1 0 4 0a2 2.6 0 1 0-4 0Z"
    + "M16.7 10.4a1.9 2.4 0 1 0 3.8 0a1.9 2.4 0 1 0-3.8 0Z";

export const PAW_SVG = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="${PAW_PATH}"/></svg>`;

export const ARROW_SVG = "<svg class=\"cc-icon\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M4.5 12h15\"/><path d=\"M13.4 5.9 19.5 12l-6.1 6.1\"/></svg>";

export const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/** Czy jest co animować (element albo niepusta lista) – GSAP nie ostrzega wtedy w konsoli. */
export const has = (target) => Boolean(target) && (target.length === undefined || target.length > 0);
